const peiSections = {
  I: '1',
  II: '2',
  III: '3',
  IV: '4',
  VI: '5',
  VII: '6',
  VIII: '7',
  IX: '8',
  X: '9',
  XI: '10',
  XII: '11',
  XIII: '12',
  // Section IV-V.
  IVV: '13',
};

export default peiSections;
